var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-subheader',[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }